/**
 *
 * @param {Object} social Botão de compartilhamento que foi clicado
 */
export function socialShare(social) {
  const socialSite = $($(social.currentTarget)[0]).attr('data-social');
  if (window.ga && ga.loaded) { // eslint-disable-line
    ga('send', 'event', 'compartilhamento', socialSite, location.href); // eslint-disable-line
  }
}

/**
 * @param {String} action Name of the type of event or interaction you want to track
 * @param {String} label Labels provide additional information for events that you want to track
 */
export default function eventAnalytics(action, label) {
  const gaObjectExists = window.ga && ga.loaded;
  if (gaObjectExists) {
    ga('send', 'event', 'metricas-interacao', action, label);
  }
}

let shouldTriggerPageViewed = true;

/**
 * Cuida do disparo quando a página é vista até o fim
 * OBS: Apenas 1 disparo por seção
 */
export function pageViewed() {
  const $window = $(window);
  const isMobile = $window.width() < 768;
  let triggerPoint;
  if (isMobile) {
    const positionFromFooter = 65;
    triggerPoint = $(document).height() - $window.height() - positionFromFooter;
  } else {
    const positionFromFooter = 80;
    triggerPoint = $(document).height() - $window.height() - positionFromFooter;
  }

  if (triggerPoint < $window.scrollTop() && shouldTriggerPageViewed) {
    eventAnalytics('fim-pagina', 'pagina-lida');
    shouldTriggerPageViewed = false;
  }
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/analytics.js